import {permissionsEnum} from '../../../serverClientShared/sharedEnums';

export const PERMISSION_LABELS = {
    [permissionsEnum.ACCESS_MEDIA]: 'Access Media',
    [permissionsEnum.ANALYTICS_TAB]: 'Analytics Tab',
    [permissionsEnum.CALL_REMOTE_SUPPORT]: 'Call Remote Support',
    [permissionsEnum.CREATE_PROCEDURE_AND_SETTINGS]: 'Create Procedure & Settings',
    [permissionsEnum.CREATE_REMOTE_SUPPORT]: 'Create Remote Support',
    [permissionsEnum.CREATE_VIRTUAL_ROOM]: 'Create Virtual Room',
    [permissionsEnum.DUPLICATE_PROCEDURE]: 'Duplicate Procedure',
    [permissionsEnum.DUPLICATE_PROJECT]: 'Duplicate Project',
    [permissionsEnum.EDIT_CAD_DATA]: 'Edit CAD Data',
    [permissionsEnum.EDIT_COLLABORATORS]: 'Edit Collaborators',
    [permissionsEnum.EDIT_PROCEDURES]: 'Edit Procedures',
    [permissionsEnum.EDIT_ROLES]: 'Edit Roles',
    [permissionsEnum.EDIT_THREE_D_MODES]: 'Edit 3D Modes',
    [permissionsEnum.GENERATE_ANALYTICS_REPORTS]: 'Generate Analytics Reports',
    [permissionsEnum.GET_CAD_DATA]: 'Get CAD Data',
    [permissionsEnum.GET_SPARE_PARTS_DATA]: 'Get Spare Parts Data',
    [permissionsEnum.UPLOAD_GUIDE_FILE]: 'Guides Upload',
    [permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION]: 'In-App Digital Twin Creation',
    [permissionsEnum.MOVE_AND_DELETE_ITEMS]: 'Move & Delete Items',
    [permissionsEnum.NEW_OBJECT_TARGET_SYSTEM]: 'New Object Target System',
    [permissionsEnum.PROJECT_DASHBOARD]: 'Project Dashboard',
    [permissionsEnum.PROJECT_SETTINGS]: 'Project Settings',
    [permissionsEnum.PUBLISH_PROCEDURE]: 'Publish Procedure',
    [permissionsEnum.SCHEDULE_REMOTE_SUPPORT]: 'Schedule Remote Support',
    [permissionsEnum.SCHEDULE_VIRTUAL_ROOM]: 'Schedule Virtual Room',
    [permissionsEnum.SUPPORT_AI_CHAT]: 'Support AI Chat',
    [permissionsEnum.SUPPORT_BOOKMARKS_CONTEXT_MENU_OPTIONS]: 'Support Bookmarks & Context Menu',
    [permissionsEnum.SUPPORT_PARTS_CATALOG_LIST]: 'Support Parts Catalog List',
    [permissionsEnum.UPDATE_DOMAIN_MATERIALS]: 'Update Domain Materials',
    [permissionsEnum.VIEW_COLLABORATORS]: 'View Collaborators',
    [permissionsEnum.VIEW_PROCEDURE_AND_MEDIA]: 'View Procedure & Media',
    [permissionsEnum.VIEW_PUBLISHED]: 'View Published',
    [permissionsEnum.VIEW_RECORDER]: 'View Recorder',
    [permissionsEnum.VIEW_REMOTE_SUPPORT]: 'View Remote Support',
    [permissionsEnum.VIEW_REMOTE_SUPPORT_DEVICE_ID]: 'View Remote Support Device ID',
    [permissionsEnum.VIEW_REMOTE_SUPPORT_USERS_LIST]: 'View Remote Support Users List',
    [permissionsEnum.VIEW_THREE_D_SCENES]: 'View 3D Scenes',
    [permissionsEnum.VIEW_UNPUBLISHED]: 'View Unpublished',
    [permissionsEnum.VIEW_VIRTUAL_ROOM]: 'View Virtual Room',
};

export const ALL_DISPLAY_PERMISSIONS = Object.keys(PERMISSION_LABELS).sort((a, b) =>
    PERMISSION_LABELS[a].localeCompare(PERMISSION_LABELS[b]),
);
